import React from "react";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { useStyles } from "./custom-card-style";
import contentBg from "assets/images/course.png";
import { Box, CardActionArea } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ELEMENT_ID, JSON_PROPERTY } from "utils/constants";
import { ProductType } from "utils/graphql/Global";
import { getJsonPropertyOrString, removeHtmlTags } from "utils/helpers";
import { RenderHTML } from "components/sanitizeHtml/sanitizeHtml";

type CustomCardProp = {
  id: string;
  item?: any;
  displayTags: boolean;
  displayId: boolean;
  onCardClick?: (event: any) => void;
};

export const CustomCard: React.FC<CustomCardProp> = ({
  id,
  item,
  displayTags,
  displayId,
  onCardClick,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const idLabel = "ID: ";

  return (
    <Card className={classes.card}>
      <CardActionArea
        id={id}
        className={classes.cardActionArea}
        onClick={onCardClick}
        role="link"
        aria-label={t("aria_label_go_to_course_details", { course: item.name })}
      >
        <CardMedia
          className={classes.media}
          image={
            process.env.REACT_APP_SHOW_DEFAULT_IMAGE_IBF.toString() === "true"
              ? contentBg
              : `${item.imageUrl}`
          }
          id={`${id}-${ELEMENT_ID.IMAGE}`}
          title={`${item.name} Card Image`}
        />
        <Box className={classes.contentWrapper}>
          <CardContent className={classes.content}>
            <Typography className={classes.contentHeader} id={`${id}-${ELEMENT_ID.NAME}`}>
              {item.name}
            </Typography>
            {displayId && (
              <Typography
                className={classes.contentId}
                id={`${id}-${ELEMENT_ID.CODE}`}
              >{`(${idLabel}${item.customerProductCode})`}</Typography>
            )}
            <Typography
              className={classes.contentDescription}
              id={`${id}-${ELEMENT_ID.DESCRIPTION}`}
            >
              {item?.productType == ProductType.PATHWAY ? (
                <RenderHTML
                  content={getJsonPropertyOrString(
                    removeHtmlTags(item?.description, ["p"]),
                    JSON_PROPERTY.MARKUP
                  )}
                />
              ) : (
                item?.description
              )}
            </Typography>
          </CardContent>
          <Box className={classes.tagsContainer} id={`${id}-${ELEMENT_ID.TAGS}`}>
            {displayTags &&
              item?.tags?.map((tag: any, id: number) => {
                return (
                  <Box className={classes.tags} key={id}>
                    {tag}
                  </Box>
                );
              })}
          </Box>
        </Box>
      </CardActionArea>
    </Card>
  );
};
